import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';

import { SharedModule } from './shared/shared.module';
import { RouterExtService } from './shared/services/router-ext/router-ext.service';
import { AuthInterceptorService } from './shared/services/auth-interceptor/auth-interceptor.service';
import { environment } from '../environments/environment';

// ngrx related imports
import { StoreModule } from '@ngrx/store';
//
import { reducers, metaReducers } from './store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { CountriesEffects } from './store/effects/countries.effects';
import { RedemptionsEffects } from './store/effects/redemptions.effects';
import { CardsEffects } from './store/effects/cards.effects';
// import { CategoriesEffects } from './store/effects/categories.effects';
// import { OffersEffects } from './store/effects/offers.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular-ivy";

// export const checkForUpdates = (locale: string): (() => Promise<any>) => {
//   return (): Promise<void> =>
//     new Promise((resolve) => {
//       if (environment?.production) {
//         if (window.location.pathname.split('/')[1] !== locale) {
//           setTimeout(() => {
//             location.href = `${window.location.origin}/${locale}`;
//           }, 500);
//           resolve();
//           return;
//         }
//       } else {
//         resolve();
//       }
//     });
// };

@NgModule({
  declarations: [
    AppComponent,
    Error404Component,
    Error500Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    // ngrx related imports
    StoreModule.forRoot(reducers, { metaReducers }),
    //
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    EffectsModule.forRoot([CountriesEffects, RedemptionsEffects, CardsEffects]),
  ],
  providers: [
    RouterExtService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: checkForUpdates,
    //   multi: true,
    //   deps: [LOCALE_ID], //dependencies
    // },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
